var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-toggle"},[_c('span',{class:_vm.$i18n.locale === 'pt-br' && 'selected',on:{"click":function () { return _vm.setLang('pt-br'); }}},[_vm._v("PT")]),_vm._v(" "),_c('span',{staticClass:"separator"},[_vm._v(_vm._s("|"))]),_vm._v(" "),_c('span',{class:_vm.$i18n.locale === 'en' && 'selected',on:{"click":function () { return _vm.setLang('en'); }}},[_vm._v("EN")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d263e24a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/SwitchLocale.vue
// module id = 184
// module chunks = 0